export default{
    newsOneTitle: '揭秘：东南亚互联网金融风控最致命的三个痛点',
    newsOneTime: "发布时间",
    newsOneRead:"阅读量",
    newsOneDetail:[
        {
            p:'不是无法信任“风控外包”，而是这种信任的成本实在太高。'
        },
        {
            p:"有数据，还是没有数据？"
        },
        {
            p:"就在上次采访了位于新加坡的一家利用“元数据”提供征信服务企业后，受访企业希望能为其推荐几家可以对接的印尼现金贷企业。秉着要促进印尼金融科技市场健康发展的宗旨，我们推荐了几家有这方面需求的企业，有包括六个月现金分期到7天14天的现金贷。"
        },
        {
            p:"这家数据征信公司的服务特点是只抓取用户使用设备的习惯数据，然后为不同的金融产品进行客制化用户信用评级打分，这种模式在没有国家信用数据中心的地区很被看好。"
        },
        {
            p:"数据是脱敏的，团队是靠谱的，市场是吻合的，而且还能解决许多人提出的东南亚信用数据缺失的问题（毕竟只要用户使用智能手机，都会产生评级所用的元数据），能看出来有很好的合作动因。"
        },
        {
            p:"但只有一点让人无法接受，这类企业需要接入现金贷公司的SDK，收集数据进行前期测试。合作意向从这里开始产生分歧。"
        },
        {
            p:"对于还在开发当地市场的现金贷企业们，已经获得的样本数据可能比什么都重要，因为老客越多意味着复借率越高，而随之而来就是获客和风控（反欺诈）成本下降，而坏账率也会一并好转。"
        },
        {
            p:"【因为没有足够数据，所以需要通过用户习惯来判断用户信用等级】,这个故事在当地团队那是能讲通的，但是在中国现金贷从业者的眼中，可能会被认为是障眼法。"
        },
        {
            p:"为什么会这样？"
        },
        {
            p:"印尼本土互金从业者们部分还属于强金融思维而弱互联网思维，希望能有一个拿来就用的信用数据库，像个被“富养“的小孩。数据一少就选择求稳，可能会错过先机。"
        },
        {
            p:"而中国带着强互联网思维的“野孩子们”并不认命，印尼移动互联网普及速度这么快，没数据完全是不成立的。无非是怎么采集这个数据，以及数据怎么评估还不是太成熟，但事在人为，且大有可为。"
        },
        {
            p:"三个环节，少一个都不行"
        },
        {
            p:"因此，中国团队的现金贷们更倾向的合作方式是第三方自己带着征信数据，而不是寄生在他们的平台做分析。这样的SAAS服务是相当有市场的，因为现在很少印尼现金贷公司在 “数据+样本+风控能力” 上是完备的，这三点几乎代表了一家现金贷能不能长期高增长。"
        },
        {
            p:"（1）数据意味着有可以量化的参考特征变量。"
        },
        {
            p:"针对数据来说，本土企业比较有优势，毕竟在与当地其他行业机构或平台谈合作时更顺畅。（当然爬虫是一种方法，但爬虫获得的数据质量很难保证，而且未必都能爬到）；"
        },
        {
            p:"（2）样本意味可以对规则或者模型做效果评估及优化。"
        },
        {
            p:"只有大玩家才有机会累计足够的样本，前期谁能付出更多的成本做量，或者找到更有效率的方法来积累样本，才能在模型的效果评估上有突破。"
        },
        {
            p:"（3）风控能力意味需要有对应的技术人才。"
        },
        {
            p:"在这一点上，其实中国团队是很有优势的，也之前写文章提到的关于印尼现金贷里面的中国力量。"
        },
        {
            p:"现阶段，几乎没有三者兼具的平台。"
        },
        {
            p:"怎样才能解决风控之痛？"
        },
        {
            p:"第一， 本地巨头企业引进风控建模能力"
        },
        {
            p:"大企业要解决这个问题是最有把握的，只是时间和资金消耗的问题。已经拿到合规注册的几家现在都在修炼“风控大法” ，常在河边走，哪有不湿鞋？手里有样本和数据，赶紧将风控能力提高才是长久之计，现在印尼奇缺风控人才，所以大家可以留意一下东南亚互金的这个 “肥差” 。"
        },
        {
            p:"第二， 出海企业更多和本土拥有数据场景的公司合作"
        },
        {
            p:"没有数据，只有自己平台手机的样本怎么办？解决方法就是要拼爹或者拼关系。东南亚数据隐私只会越来约严格，大的平台愿意分享数据的出发点在哪里？找到一个突破口，很可能就成为东南亚的“趣店”，虽然只是成长期的。"
        },
        {
            p:"第三， 出海互金企业结盟，共享数据"
        },
        {
            p:"如果是什么没有的小玩家，那就大家抱团取暖。这个也许不是非常高效，但是企业之间在征信数据上结盟并不算是非常罕见的事情。这中风险比直接外包风控要低一些，毕竟有联盟的约束。"
        },
        {
            p:"这样的建议我们听到有现金贷企业负责人曾经提出来过，而且有几家已经在共享这些数据。并非无法实现，毕竟众人拾柴火焰高。市场还远远没有定论，蛋糕还在做，没到分蛋糕的时候。"
        },
        {
            p:"在上次印尼政府放出消息要在6月出台新监管政策之后，火了一年多的印尼消费金融（特别是现金贷）也应该迎来优胜劣汰的时代了。如果你说自己的路子野，提高利息，然后做好反欺诈防止黑产来袭，做什么风控？那实在对不住，这种饮鸩止渴的方式在未来监管的大环境下，只能“猥琐发育，小打小闹”。印尼监管局发话了，说希望看到当地的贷款公司将利息降下去，你还不遵守吗？"
        },
        {
            p:"利息降下去还想挣钱的话，那就做好风控吧。"
        }

        
    ]
}